module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Log in","problem":{"401_2":"Incorrect email address and/or password."}}}')
  delete Component.options._Ctor
}
